import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddPost from "root/Modals/AddPost/ModalAddPost";

const useModalAddPost = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', child_uid: null, post_id: null, adultPost: null, messageType: null, page: null })  ;

    const onClickActivate = ( mode, child_uid, post_id, adultPost, messageType, page ) =>
    {
        setDialog ({ openState: true, child_uid: child_uid, post_id: post_id, mode: mode, adultPost: adultPost, messageType: messageType, page:page});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, key: null, mode: 'none'});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddPost child_uid={dialog.child_uid} post_id={dialog.post_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal}
                                              mode={dialog.mode} adultPost={dialog.adultPost} messageType={dialog.messageType} page={dialog.page}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddPost ;
